import Styles from './FocusModeNavbar.module.scss'

export const FocusModeNavbar = () => {
  return (
    <div className={Styles.focusModeNavbar}>
      <div className={Styles.spacer}>
        <div className={Styles.focusModeShortcutMessage}>
          <div className={Styles.focusModePill}>ESC</div>
          <div>to Exit</div>
        </div>
      </div>

      <div className={Styles.focusModePillLg}>Focus Mode</div>
    </div>
  )
}
